import { gql } from '@apollo/client';

export const NOTIFICATION = gql`
    mutation sendNotificationOperator($input: NewNotification!) {
        sendNotificationOperator(input: $input)
    }
`;